import React from 'react'
import './buildingProgressBlockedCard.scss'
import purpleRectangle from './../../../../assets/img/metaberry_ui/purple-rectangle2.png'
import lockImage from './../../../../assets/img/metaberry_ui/lock.png'

const BuildingProgressBlockedCard = ({ index, title }) => {
  return (
    <div className="building-progress-blocked-card__container">
      <img
        className="building-progress-blocked-card__purple-rectangle-background"
        src={purpleRectangle}
      />
      <div className="building-progress-blocked-card__white-circle-number">
        {index}
      </div>
      <div className="building-progress-blocked-card__content">
        <div className="building-progress-blocked-card__title">{title}</div>
        <div className="building-progress-card__grey-circle">
          <img
            className="building-progress-card__lock-image"
            src={lockImage}
          ></img>
        </div>
      </div>
    </div>
  )
}

export default BuildingProgressBlockedCard
